// Enlace de regreso a la lista «Mensajes automáticos» (F2 reorden 24-oct-2026). Lo pintan los 8 editores de
// mensaje por evento, que ya no tienen entrada propia en el menú: se llega a ellos desde la lista.
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const VolverAMensajes: React.FC = () => (
  <RouterLink to="/dashboard/mensajes" data-testid="volver-mensajes" className="inline-flex items-center text-sm font-medium text-accent hover:underline mb-2">
    <ArrowLeft className="h-4 w-4 mr-1" /> Mensajes automáticos
  </RouterLink>
);

export default VolverAMensajes;
